import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';
import { ConstantsService } from '../common/services/constants.service';

const httpOptions = {     
    headers: new HttpHeaders({        
        'Content-Type':  'application/json; charset=utf-8',   
        'Authorization': ConstantsService.AUTH_TOKEN, 
    })    
};

@Injectable()
export class StudentService {
    constructor(private http: HttpClient) { }

    getStudents(rootUrl:string, usercode: string, assessor_id:number, exam_id: number):Observable<any> {
        return this.http.post<any>(rootUrl+'assessor/students', {usercode: usercode, assessor_id:assessor_id, exam_id:exam_id}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    getStudentsForBatch(rootUrl:string, usercode: string, assessor_id:number, exam_id: number):Observable<any> {
        return this.http.post<any>(rootUrl+'assessor/students/bybatch', {usercode: usercode, assessor_id:assessor_id, exam_id:exam_id}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }


    getStudentsList(rootUrl:string, usercode: string, assessor_id:number, exam_id: number):Observable<any> {
        return this.http.post<any>(rootUrl+'assessor/student/list', {usercode: usercode, assessor_id:assessor_id, exam_id:exam_id}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    getExamsData(rootUrl:string, usercode: string, assessor_id:number, exam_ids: any):Observable<any> {
        return this.http.post<any>(rootUrl+'assessor/exam/list', {usercode: usercode, assessor_id:assessor_id, exam_ids:exam_ids}, httpOptions)
            .pipe(map(response => {
                return response;
            })
        );
    }

    practical(rootUrl:string, usercode: string,assessor_id:number,exam_id: number):Observable<any> {
        return this.http.post<any>(rootUrl+'assessor/pracstudentlist', {usercode: usercode, assessor_id:assessor_id,exam_id:exam_id}, httpOptions)
            .pipe(map(response => {
                return response;
            })
        );
    }

    pracStudent(rootUrl:string, usercode: string,student_id:number,practical_id:number,assessor_id:number,exam_id: number):Observable<any> {
        return this.http.post<any>(rootUrl+'assessor/startpractical', {usercode: usercode,student_id:student_id,practical_id, assessor_id:assessor_id,exam_id:exam_id}, httpOptions)
            .pipe(map(response => {
                return response;
            })
        );
    }
    setPracMarks(rootUrl:string, usercode: string,student_id:number,practical_id:number,assessor_id:number,exam_id: number,comments:string,maxMarks:number):Observable<any> {
        return this.http.post<any>(rootUrl+'assessor/markspractical', {usercode: usercode,student_id:student_id,practical_id:practical_id, assessor_id:assessor_id,exam_id:exam_id,comments:comments,maxmarks:maxMarks}, httpOptions)
            .pipe(map(response => {
                return response;
            })
        );
    }

    endPractical(rootUrl:string, usercode: string,assessor_id:number,exam_id: number,student_id:number,practical_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'assessor/endpractical', {usercode: usercode, assessor_id:assessor_id,exam_id:exam_id,student_id:student_id,practical_id:practical_id}, httpOptions)
            .pipe(map(response => {
                return response;
            })
        );
    }

    practicalNos(rootUrl:string, usercode: string,student_id:number,practical_id:number,assessor_id:number,exam_id: number):Observable<any> {
        return this.http.post<any>(rootUrl+'assessor/noslist', {usercode: usercode,student_id:student_id,practical_id, assessor_id:assessor_id,exam_id:exam_id}, httpOptions)
            .pipe(map(response => {
                return response;
            })
        );
    }

    descriptiveStudentlist(rootUrl:string, usercode: string,assessor_id:number,exam_id: number):Observable<any> {
        return this.http.post<any>(rootUrl+'assessor/getDescriptiveStudentList', {usercode: usercode, assessor_id:assessor_id,exam_id:exam_id}, httpOptions)
            .pipe(map(response => {
                return response;
            })
        );
    }
    descriptiveMarks(rootUrl:string, usercode: string,assessor_id:number,exam_id: number,student_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'assessor/getStudentAnswers', {usercode: usercode, assessor_id:assessor_id,exam_id:exam_id,student_id:student_id}, httpOptions)
            .pipe(map(response => {
                return response;
            })
        );
    }

    setDescriptiveMarks(rootUrl:string, usercode: string,assessor_id:number,exam_id: number,marks:any,student_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'assessor/setDescriptiveMarks', {usercode: usercode, assessor_id:assessor_id,exam_id:exam_id,marks:marks,student_id:student_id,}, httpOptions)
            .pipe(map(response => {
                return response;
            })
        );
    }

    vivaStudentlist(rootUrl:string, usercode: string,assessor_id:number,exam_id: number):Observable<any> {
        return this.http.post<any>(rootUrl+'assessor/getVivaStudentList', {usercode: usercode, assessor_id:assessor_id,exam_id:exam_id}, httpOptions)
            .pipe(map(response => {
                return response;
            })
        );
    }
    getVivaAnswers(rootUrl:string, usercode: string,assessor_id:number,exam_id: number,student_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'assessor/getStudentVivaAnswers', {usercode: usercode, assessor_id:assessor_id,exam_id:exam_id,student_id:student_id}, httpOptions)
            .pipe(map(response => {
                return response;
            })
        );
    }

    setvivaMarks(rootUrl:string, usercode: string,assessor_id:number,exam_id: number,marks:any,student_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'assessor/setvivaMarks', {usercode: usercode, assessor_id:assessor_id,exam_id:exam_id,marks:marks,student_id:student_id,}, httpOptions)
            .pipe(map(response => {
                return response;
            })
        );
    }

    chat(rootUrl:string, usercode: string,assessor_id:number,exam_id: number,student_id:number,practical_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'chat/practicalChat', {usercode: usercode, assessor_id:assessor_id,exam_id:exam_id,student_id:student_id,practical_id:practical_id}, httpOptions)
            .pipe(map(response => {
                return response;
            })
        );
    }
    matrixAssessStudentlist(rootUrl:string, usercode: string,assessor_id:number,exam_id: number):Observable<any> {
        return this.http.post<any>(rootUrl+'assessor/k/studentListMatrix', {usercode: usercode, assessor_id:assessor_id,exam_id:exam_id}, httpOptions)
            .pipe(map(response => {
                return response;
            })
        );
    }
    practicalStudentlist(rootUrl:string, usercode: string,assessor_id:number,exam_id: number):Observable<any> {
        return this.http.post<any>(rootUrl+'assessor/practicalviva/students', {usercode: usercode, assessor_id:assessor_id,exam_id:exam_id}, httpOptions)
            .pipe(map(response => {
                return response;
            })
        );
    }    
}